/** Filename / display fallback when no as-at date is stored on the config. */
export function defaultAsAtDateForFilename(): string {
  return new Date().toISOString().split("T")[0];
}
